import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs';
import { debugFlagActions } from '../actions';
import { DebugFlagsStorageService } from '../services';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/effects";
import * as i2 from "../services";
export class DebugFlagEffects {
    constructor(debugFlagActions$, debugFlagsStorage) {
        this.debugFlagActions$ = debugFlagActions$;
        this.debugFlagsStorage = debugFlagsStorage;
        this.load$ = createEffect(() => this.debugFlagActions$.pipe(ofType(debugFlagActions.ActionTypes.LoadDebugFlags), map(() => new debugFlagActions.LoadSuccess(this.debugFlagsStorage.getFromLocalStorage() || {}))));
        this.set$ = createEffect(() => this.debugFlagActions$.pipe(ofType(debugFlagActions.ActionTypes.SetDebugFlags), map((action) => action.payload), tap(payload => this.debugFlagsStorage.saveToLocalStorage(payload))), { dispatch: false });
    }
    static { this.ɵfac = function DebugFlagEffects_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DebugFlagEffects)(i0.ɵɵinject(i1.Actions), i0.ɵɵinject(i2.DebugFlagsStorageService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DebugFlagEffects, factory: DebugFlagEffects.ɵfac }); }
}
//# sourceMappingURL=debug-flag.effects.js.map